import { GET_IPD_ADMISSION_ESTIMATE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
}

interface AdmissionEstimate {
    name: string;
    service: string;
    rate: number;
    quantity: number;
    discount: Discount;
}

export interface Discount {
    category: string;
    value: number;
}

export default (aid: string, estimates: AdmissionEstimate[]): Promise<Response> => {
    return fetchWithRefresh(GET_IPD_ADMISSION_ESTIMATE(aid), {
        method: 'POST',
        body: JSON.stringify({ items: estimates }),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
